import { AsynchronousRequisitesProps } from "../../types/common";
import AsynchronousRequisites from "./Asynchronous/AsynchronousRequisites";

export const ResidentNameSelect = ({
    onChange,
    value,
    field,
    error,
    callbackResult,
    id,
    label,
}: Omit<AsynchronousRequisitesProps, "onChange" | "getParam"> & { onChange: (value: string) => void }) => {
    return (
        <AsynchronousRequisites
            onChange={item => {
                onChange(item?.name ?? "");
            }}
            getParam="name"
            value={value}
            label={label ?? "ФИО"}
            error={error}
            callbackResult={callbackResult}
            id={id}
        />
    );
};
